<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" :class="[`${prefix}-icon`, `${prefix}-icon-lxr`]" width="1em" height="1em" v-bind="$attrs"><rect x="2" y="2" width="5" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/><rect x="9" y="4" width="5" height="10" rx="1" stroke="currentColor" stroke-width="1.5"/><path d="M4.5 11v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconLxr',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
